import { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useUser, useActions } from '@mssgme/hooks';
import { getConversation, getTeamMembers } from '@mssgme/store';

export default function useAssignTo(contactId) {
    const { t } = useTranslation('inbox');
    const { api } = useActions();
    const { id: userId } = useUser();
    const { members, assignTo } = useSelector((state) => ({
        members: getTeamMembers(state),
        assignTo: getConversation(state, contactId).assignTo,
    }));
    const [value, setValue] = useState(assignTo);

    useEffect(() => {
        setValue(assignTo);
    }, [assignTo]);

    const placeholder = t('assignTo.unassigned');

    const onChange = (v) => {
        if (value !== v) {
            setValue(v);
            api.conversations.assign({ contactId, userId: v });
        }
    };

    const options = useMemo(
        () =>
            members.map(({ id, name, avatarUrl }) => ({
                label: userId === id ? t('assignTo.me') : name,
                value: id,
                meta: {
                    avatar: { name: name, src: avatarUrl },
                },
            })),
        [members, userId, t]
    );

    return { value, onChange, placeholder, options };
}
